// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import { format } from 'date-fns';
// Material UI ( mui ) components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';

// Section for import custom components --------------------------------------------------------------------------------

// Section for render component ----------------------------------------------------------------------------------------

// Section for type definition -----------------------------------------------------------------------------------------
import MansionContractHistoryPropsData from '@/types/components/MansionDetail/MansionContractHistoryPropsData';

type MansionContractHistoryProps = {
  mansionContractHistory: MansionContractHistoryPropsData[];
};

export default function MansionContractHistories(props: MansionContractHistoryProps) {
  const { mansionContractHistory } = props;
  return (
    <Box id="mansionContractHistory" className="py-2 max-md:py-1">
      <Container className="md:max-w-7xl md:w-full md:mx-auto md:px-24">
        <Box className="px-10 max-md:px-4 py-6 max-md:py-5 bg-[#E6EBF0] rounded-lg">
          <Box className="flex justify-center items-center gap-3 h-9 mb-6 rounded-lg balloon-contract">
            <HandshakeRoundedIcon className="text-rf-navy" />
            <Typography
              component="h3"
              variant="h3"
              className="text-base text-rf-navy font-bold text-center leading-relaxed max-md:leading-[22px] tracking-wide"
            >
              購入のお手伝いをしました！
            </Typography>
          </Box>
          {mansionContractHistory.map((history) => (
            <Box key={history.id} className="mt-5 mx-auto flex flex-col gap-2">
              <Typography className="text-base max-md:text-sm tracking-wide">{history.contractDescription}</Typography>
              <Box className="flex flex-wrap justify-end gap-x-2">
                <Typography className="text-xs text-[#000000]">{history.fcShopName}</Typography>
                <Typography className="text-xs text-[#000000]">
                  {format(new Date(history.contractDate), 'yyyy/MM/dd')}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
